import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { EmployeeFileUploadComponent } from './employee-file-upload.component';

@NgModule({
  declarations: [EmployeeFileUploadComponent],
  imports: [
    CommonModule,
    DropzoneModule
  ],
  exports: [EmployeeFileUploadComponent],
  entryComponents: [EmployeeFileUploadComponent]
})
export class EmployeeFileUploadModule { }
